import { useState, useEffect } from 'react'
import { getEmpsNameAPI, getEmpsTypeDateAPI } from '../services/employee'

function UseEmpsTypeDate(orgId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsTypeDateAPI()
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return {
          value: d.id,
          label: `${d.type_date}`
        }
      })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId])

  return data
}

export default UseEmpsTypeDate
